export default class Event {
    constructor(titles, tagLines, contents, categories, files, images, featuredImage, publishDate, startDate, endDate, price, time, contact, address, latitude, longitude) {
        // Translations fields
        this.titles = titles;
        this.tagLines = tagLines;
        this.contents = contents;

        // Arrays
        this.categories = categories;
        this.files = files;
        this.images = images;
        
        
        this.featuredImage = featuredImage;
        this.publishDate = publishDate;
        this.startDate = startDate;
        this.endDate = endDate;
        this.price = price;
        this.time = time;
        this.contact = contact;
        this.address = address;
        this.latitude = latitude;
        this.longitude = longitude;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.tagLines)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; }

        if(result) result = this.categories && this.categories.length && this.featuredImage && this.startDate && this.endDate && this.price && this.time && this.contact && this.address && this.latitude && this.longitude;
        
        return result;
    }
}